import { useContext, useState, useEffect } from 'react';
import { SiteContext } from 'application/adapters/context/SiteContext';
import { PageContext } from 'application/adapters/context/PageContext';
import { HeaderGlobal } from 'ui/components/4-habitats/HeaderGlobal/HeaderGlobal';
import { useNavigationContext } from 'application/adapters/context/NavigationContext';
import { Profiles } from 'application/repositories/profilesRepository';
import { ProfileContext } from 'application/adapters/context/Profile';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export const HeaderGlobalFeature: React.FC = () => {
	const siteContext = useContext(SiteContext);
	const pageContext = useContext(PageContext);
	const dictionary = useContext(DictionaryContext);
	const { getNavItems } = useNavigationContext();
	const navGroupsItems = getNavItems?.(pageContext.id) ?? [];
	const serviceNavigationItems = siteContext.getSettings('serviceNavigation');
	const languageBarItems = siteContext.getSettings('languageBar');
	const languageBarTitle = siteContext.getSettings('languageBar');
	const portalList = siteContext.getSettings('portalList');
	const portalStateLabel = dictionary.getValue('PortalList.StateLabel', undefined, 'Du er på');
	const userTools = siteContext.getSettings('userTools');
	const signUpLabel = dictionary.getValue('Authentication.SignUpLabel', undefined, 'Bliv medlem');
	const searchPageUrl = siteContext.getSettings('searchResultsUrl')?.searchResultsPageUrl;
	const searchLabel = dictionary.getValue('Search.Search', undefined, 'Søg');
	const navigationMenuLabel = dictionary.getValue('Action.Menu', undefined, 'Menu');
	const [profiles, setProfiles] = useState<Profiles>(null);

	const profileContext = useContext(ProfileContext);
	const profile = profileContext.profile;

	useEffect(() => {
		if (profile) {
			setProfiles(profile);
		}
	}, [profile]);

	return (
		<HeaderGlobal
			navGroups={navGroupsItems}
			serviceNavigationItems={serviceNavigationItems}
			userTools={userTools}
			portalList={portalList}
			languageBarTitle={languageBarTitle}
			languageBarItems={languageBarItems}
			profiles={profiles}
			searchPageUrl={searchPageUrl}
			portalStateLabel={portalStateLabel}
			signUpLabel={signUpLabel}
			searchLabel={searchLabel}
			navigationMenuLabel={navigationMenuLabel}
		/>
	);
};
